module.exports = __webpack_public_path__ + "assets/img/20_52.0a939356.jpg";